import { render, staticRenderFns } from "./no-header.vue?vue&type=template&id=60435592"
import script from "./no-header.vue?vue&type=script&lang=js"
export * from "./no-header.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/members-area.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports